// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-bar-button{min-width:32px;padding:2px}`, "",{"version":3,"sources":["webpack://./src/components/floating-bar/floating-bar-button.css"],"names":[],"mappings":"AAAA,qBAEC,cAAe,CADf,WAED","sourcesContent":[".floating-bar-button {\n\tpadding: 2px 2px;\n\tmin-width: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
